__turbopack_context__.v({
  "root": "LabelledToggle-module__sJifkG__root",
});
